"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mottoPalette = void 0;
var palette_1 = require("../../shared/palette");
var palette = {
    primary: {
        '100': '#F5F9FF',
        '300': '#E9F1FB',
        '500': '#0B2341',
        '700': '#091C34',
        '900': '#071527',
    },
    secondary: {
        '100': '#F5F9FF',
        '300': '#E9F1FB',
        '500': '#0B2341',
        '700': '#091C34',
        '900': '#071527',
    },
    tertiary: {
        '100': '#F7FFFF',
        '300': '#DBF0F0',
        '500': '#22A3A6',
        '700': '#005959',
        '900': '#003D3D',
    },
    neutrals: __assign(__assign({}, palette_1.commonNeutrals), { '100': '#F2F3F4', '300': '#D6D9DA', '500': '#A7ADB0', '700': '#696E72', '900': '#434A4F' }),
    text: __assign(__assign({}, palette_1.commonTextColors), { disabled: '#A7ADB0', tertiary: '#696E72', secondary: '#434A4F', primary: '#0B2341', interactive: '#008081' }),
    accent01: {
        '100': '#FFFDFA',
        '300': '#FEEACD',
        '500': '#FCD192',
        '700': '#F9AC39',
        '900': '#D28006',
    },
    accent02: {
        '100': '#FFF7F9',
        '300': '#FBCBD9',
        '500': '#E17090',
        '700': '#C33D63',
        '900': '#A93153',
    },
    accent03: {
        '100': '#F7FFFF',
        '300': '#DBF0F0',
        '500': '#5CB9BB',
        '700': '#22A3A6',
        '900': '#008081',
    },
    accent04: {
        '100': '#EBF9FD',
        '300': '#C5EEF8',
        '500': '#3BC7E9',
        '700': '#2F9FBA',
        '900': '#23778C',
    },
    success: __assign(__assign({}, palette_1.commonSuccess), { '700': '#027356' }),
    error: __assign({}, palette_1.commonError),
    warning: __assign({}, palette_1.commonWarning),
    info: __assign({}, palette_1.commonInfo),
    background: __assign(__assign(__assign({}, palette_1.commonBackgroundColors), palette_1.commonGradients), { neutral: '#FFFAF4', light: '#DBF0F0', lightTwo: '#FEEACD', lightThree: '#FBCBD9', dark: '#0B2341', darkTwo: '#008081', neutralGradient: 'linear-gradient(180deg, #E7E7E7 0%, #FFFFFF 70%)', lightGradient: 'linear-gradient(180deg, #B2E4E5 0%, #DBF0F0 100%)', lightTwoGradient: 'linear-gradient(180deg, #FFD9A1 0%, #FEEACD 70%)', lightThreeGradient: 'linear-gradient(180deg, #FFADC5 0%, #FBCBD9 70%)', darkGradient: 'linear-gradient(165deg, #091B33 4.91%, #123869 89.46%)', ODPHeroGradient: 'linear-gradient(97deg, rgba(11, 35, 65, 0.85) 33.86%, rgba(11, 35, 65, 0.00) 73.68%)' }),
};
exports.mottoPalette = {
    primary: {
        lightest: palette.primary[100],
        light: palette.primary[300],
        main: palette.primary[500],
        dark: palette.primary[700],
        darkest: palette.primary[900],
    },
    secondary: {
        lightest: palette.secondary[100],
        light: palette.secondary[300],
        main: palette.secondary[500],
        dark: palette.secondary[700],
        darkest: palette.secondary[900],
    },
    tertiary: {
        lightest: palette.tertiary[100],
        light: palette.tertiary[300],
        main: palette.tertiary[500],
        dark: palette.tertiary[700],
        darkest: palette.tertiary[900],
    },
    neutrals: {
        white: palette.neutrals.white,
        neutral: palette.neutrals[100],
        primary: palette.neutrals[300],
        disabled: palette.neutrals[500],
        secondary: palette.neutrals[900],
        tertiary: palette.neutrals[700],
    },
    text: {
        primary: palette.text.primary,
        secondary: palette.text.secondary,
        tertiary: palette.text.tertiary,
        light: palette.text.light,
        disabled: palette.text.disabled,
        interactive: palette.text.interactive,
    },
    accent01: {
        lightest: palette.accent01[100],
        light: palette.accent01[300],
        main: palette.accent01[500],
        dark: palette.accent01[700],
        darkest: palette.accent01[900],
    },
    accent02: {
        lightest: palette.accent02[100],
        light: palette.accent02[300],
        main: palette.accent02[500],
        dark: palette.accent02[700],
        darkest: palette.accent02[900],
    },
    accent03: {
        lightest: palette.accent03[100],
        light: palette.accent03[300],
        main: palette.accent03[500],
        dark: palette.accent03[700],
        darkest: palette.accent03[900],
    },
    accent04: {
        lightest: palette.accent04[100],
        light: palette.accent04[300],
        main: palette.accent04[500],
        dark: palette.accent04[700],
        darkest: palette.accent04[900],
    },
    success: {
        light: palette.success[300],
        main: palette.success[500],
        dark: palette.success[700],
    },
    error: {
        light: palette.error[300],
        main: palette.error[500],
        dark: palette.error[700],
    },
    warning: {
        light: palette.warning[300],
        main: palette.warning[500],
        dark: palette.warning[700],
    },
    info: {
        light: palette.info[300],
        main: palette.info[500],
        dark: palette.info[700],
    },
    backgrounds: __assign({}, palette.background),
};
